import { takeLatest, put } from 'redux-saga/effects';

import { actions as errorActions } from 'state/errors';
import { constants as aditionalOptionsConstants } from 'utils/aditionalOptions';

import { actions as orderActions } from 'state/order';
import actions from 'state/direct-order/insurance/actionCreators';

import types from 'state/direct-order/insurance/actionTypes';

function* handleSetInsuranceFor({ payload }) {
  const { insuranceQuantity } = payload;
  const key = aditionalOptionsConstants.ADITIONAL_OPTIONS.INSURANCE;

  yield put(actions.setInsuranceQuantity(insuranceQuantity));
  yield put(errorActions.removeError([key]));
  const hasError =
    insuranceQuantity > aditionalOptionsConstants.INSURANCE_MAX_QUANTITY;

  if (hasError) {
    const errors = { [key]: '***error insurance quantity' };
    yield put(errorActions.setError(errors));
  } else {
    yield put(orderActions.fetchQuote());
  }
}

export default function* () {
  yield takeLatest(types.setInsuranceFor$, handleSetInsuranceFor);
}

export { handleSetInsuranceFor };
